export default __webpack_public_path__ + "static/media/slider-img-2.de2bf565.png";